import { initExperimentsGetter, initLoadedExperimentsGetter, } from '../fetchExperiments';
import { assertEnabledApi } from '../util';
var FlowAPI = /** @class */ (function () {
    function FlowAPI(_a) {
        var experimentsConfig = _a.experimentsConfig, prepopulatedData = _a.prepopulatedData, httpClient = _a.httpClient;
        this.reportError = function (error) {
            console.warn("You are trying to report an error, but didn't configure sentry in `.application.json`\n\nPlease read the docs for more information https://bo.wix.com/pages/yoshi/docs/editor-flow/structure-api/app-configuration/#applicationjson", 'Error: ', error);
        };
        var prepopulatedExperiments = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.experiments;
        if (prepopulatedExperiments || !experimentsConfig) {
            this.getExperiments = initLoadedExperimentsGetter(prepopulatedExperiments);
        }
        else {
            this.getExperiments = initExperimentsGetter(experimentsConfig);
        }
        this._httpClient = httpClient;
    }
    Object.defineProperty(FlowAPI.prototype, "httpClient", {
        get: function () {
            var _httpClient = this._httpClient;
            assertEnabledApi(_httpClient, 'HttpClient');
            return _httpClient;
        },
        enumerable: false,
        configurable: true
    });
    return FlowAPI;
}());
export { FlowAPI };
//# sourceMappingURL=Base.js.map